/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react"
import { Col, Row } from "react-bootstrap"
import { Container } from "react-bootstrap"
import { useDrag } from "react-dnd"
import { TZyutyuHaisyaListGetRes } from "../../../service/order/zyutyuHaisya/TZyutyuHaisya"

import util from "../../../ts/util"
import { eTabs, ItemType } from "./HaisyaRegister"

/**
 * 未配車一覧
 * @returns
 */
const MihaisyaCard: React.FC<{
  haisyaInfo: TZyutyuHaisyaListGetRes
  onDoubleClick?: React.MouseEventHandler<HTMLDivElement>
  displayTab: string
}> = (props) => {
  const is付替受 =
    props.haisyaInfo.受注部所コード !== props.haisyaInfo.運行部所コード
  let defaultClassName = "mihaisya-card rounded"
  if (is付替受) {
    defaultClassName += " tukekae"
  }
  const [className, setClassName] = useState(defaultClassName)

  const [
    { isDragging },
    dragRef,
    //    dragPreviewRef
  ] = useDrag(() => {
    if (props.displayTab === eTabs["1日"]) {
      return {
        type: ItemType.配車,
        item: props.haisyaInfo,
        collect: (c) => ({ isDragging: c.isDragging() }),
      }
    } else {
      return {
        type: ItemType.配車日単位,
        item: {
          受注配車: props.haisyaInfo,
        },
        collect: (c) => ({ isDragging: c.isDragging() }),
      }
    }
  }, [props.haisyaInfo])
  const opacity = isDragging ? 0.4 : 1

  useEffect(() => {
    const dragging = isDragging ? " dragging" : ""
    setClassName(defaultClassName + dragging)
  }, [isDragging])

  return (
    <div
      ref={dragRef}
      onDoubleClick={props.onDoubleClick}
      className={className}
      style={{
        opacity,
        cursor: isDragging ? "grabbing" : "grab",
      }}>
      <Container fluid className="px-2">
        <Row className="align-middle" style={{ minHeight: "2rem" }}>
          <Col xs={12}>
            <table className="w-100">
              <tbody>
                <tr>
                  <td>{props.haisyaInfo.荷主コード}</td>
                  <td>{props.haisyaInfo.荷主名}</td>
                  <td colSpan={2}>
                    {props.haisyaInfo.品名}{" "}
                    {props.haisyaInfo.積載品数量 && props.haisyaInfo.積載品数量}
                    {props.haisyaInfo.積載品数量 &&
                      props.haisyaInfo.単位区分名称1 &&
                      props.haisyaInfo.単位区分名称1}
                  </td>
                </tr>
                <tr>
                  <td>{util.date.format(props.haisyaInfo.積日, "MM/DD")}</td>
                  <td colSpan={2}>
                    {props.haisyaInfo.積地社名}
                    {props.haisyaInfo.積地社名 &&
                      props.haisyaInfo.積地市区町村 &&
                      "/"}
                    {props.haisyaInfo.積地市区町村}
                  </td>
                  <td className="text-danger text-end">
                    {is付替受 && "他部所"}
                  </td>
                </tr>
                <tr>
                  <td> {util.date.format(props.haisyaInfo.卸日, "MM/DD")}</td>
                  <td colSpan={2}>
                    {props.haisyaInfo.卸地社名}
                    {props.haisyaInfo.卸地社名 &&
                      props.haisyaInfo.卸地市区町村 &&
                      "/"}
                    {props.haisyaInfo.卸地市区町村}
                  </td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default MihaisyaCard
